module.exports = __webpack_public_path__ + "img/2025-08-16c_7.0ab732d2.jpg";